import { makeStyles } from '@material-ui/core/styles'
import Color from 'color'

const styles = makeStyles(theme => {
  const pinkColor = Color(theme.palette.pink.main)
  return {
    purchase: {
      display: 'flex',
      alignItems: 'center',
      margin: 0,
      padding: theme.spacing(1, 2.125),
      paddingRight: theme.spacing(5.75),
      '&:nth-of-type(odd)': {
        backgroundColor: '#F1F1F1'
      }
    },
    chip: {
      flexGrow: 0,
      flexShrink: 0,
      backgroundColor: pinkColor.alpha('.23').string(),
      marginRight: theme.spacing(2.25),
      color: theme.palette.text.primary,
      minWidth: 62
    },
    purchaserName: {
      fontFamily: 'Poppins, Open Sans, sans-serif',
      fontSize: '1rem',
      fontWeight: 'normal',
      justifySelf: 'flex-end',
      flexGrow: 1
    },
    purchaseAmount: {
      fontFamily: 'Poppins, Open Sans, sans-serif',
      fontSize: '1.25rem',
      fontWeight: 'normal'
    },
    winningPurchase: {
      padding: theme.spacing(2.25, 2.625),
      paddingRight: theme.spacing(3.375),
      color: 'white',
      background:
        'linear-gradient(130deg, rgba(235,46,107,1) 0%, rgba(26,163,255,1) 100%)',
      fallbacks: {
        background: 'rgb(235,46,107)'
      },
      '& $chip': {
        backgroundColor: 'white',
        color: pinkColor.string()
      },
      '& $purchaserName': {
        fontWeight: 800
      },
      '& $purchaseAmount': {
        fontWeight: 800
      }
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/PurchaseList/Purchase/styles.js